class DialogManager {
  constructor() {
    return
    this.stack = []
    this.listeners = {}
    this.opening = new Set()
    this.closing = new Set()
    this.currentPath = location.pathname + location.search + location.hash

    window.addEventListener('popstate', event => {
      this.handlePopState(event)
    })

    this.observeRouteChange()
  }

  register(id, onClose) {
    return
    this.listeners[id] = onClose
  }

  unregister(id) {
    return
    delete this.listeners[id]
    this.stack = this.stack.filter(d => d !== id)
    this.opening.delete(id)
    this.closing.delete(id)
  }

  open(id) {
    return
    if (this.stack.includes(id) || this.opening.has(id)) return
    this.stack.push(id)
    this.opening.add(id)
    history.pushState({ dialogId: id }, '')
    setTimeout(() => this.opening.delete(id))
  }

  close(id, triggeredByBack = false, isForceClose = false) {
    return
    console.log("🚀 ~ DialogManager ~ close ~ id:", id)
    if (!this.stack.includes(id) || this.closing.has(id)) return
    this.stack = this.stack.filter(d => d !== id)
    this.closing.add(id)

    if (!triggeredByBack && !isForceClose) {
      history.back()
    }

    setTimeout(() => this.closing.delete(id), 500)
  }

  handlePopState(event) {
    return
    if (this.stack.length === 0) return
    if(this.closing.size) return
    
    const state = event.state

    if (!state || !state.dialogId) {
      this.closeAll(true)
      return
    }

    const idx = this.stack.indexOf(state.dialogId)
    console.log("🚀 ~ DialogManager ~ handlePopState ~ idx:", idx)
    console.log("🚀 ~ DialogManager ~ handlePopState ~ state:", state)
    if (idx === -1) {
      this.closeAll(true)
    } else {
      while (this.stack.length - 1 > idx) {
        const id = this.stack.pop()
        const listener = this.listeners[id]
        if (listener) listener(true)
      }
    }
  }

  closeAll(triggeredByBack = false, isForceClose = false) {
    return
    while (this.stack.length) {
      const id = this.stack.pop()
      const listener = this.listeners[id]
      if (listener) listener(triggeredByBack, isForceClose)
    }
  }

  observeRouteChange() {
    return
    // vérifie en continu si la route a changé
    const checkRoute = () => {
      const newPath = location.pathname + location.search + location.hash
      if (newPath !== this.currentPath) {
        this.currentPath = newPath
        // route changée → fermer tous les dialogues
        this.closeAll(false, true)
      }
      requestAnimationFrame(checkRoute)
    }
    requestAnimationFrame(checkRoute)
  }
}

export const dialogManager = new DialogManager()
